var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard__navbar"},[_c('div',{staticClass:"dashboard__navbar-wrap"},[_c('svgicon',{staticClass:"sidebar__menu",attrs:{"icon":"menu"},on:{"click":_vm.toggleSidebar}}),_vm._v(" "),_c('p',{staticClass:"dashboard__navbar-title"},[_vm._v("\n      "+_vm._s(_vm.currentRouteName == "dashboard"
          ? "Overview"
          : _vm.currentRouteName == "listing"
          ? "Listings"
          : _vm.currentRouteName == "listingDetail"
          ? "Listing"
          : _vm.currentRouteName == "member"
          ? "Members"
          : _vm.currentRouteName == "memberDetail"
          ? "Members"
          : _vm.currentRouteName == "booking"
          ? "Bookings"
          : _vm.currentRouteName == "referral"
          ? "Referrals"
          : _vm.currentRouteName == "referrerDetail"
          ? "Referrer Details"
          : _vm.currentRouteName == "bookingDetail"
          ? "Bookings"
          : _vm.currentRouteName == "subscription"
          ? "Subscriptions"
          : _vm.currentRouteName == "subscriptionDetail"
          ? "Subscriptions"
          : _vm.currentRouteName == "lost"
          ? "We lost you"
          : _vm.currentRouteName == "lost-two"
          ? "We lost you"
          : _vm.currentRouteName == "invoices"
          ? "Invoices"
          : _vm.currentRouteName == "maintenance"
          ? "Maintenance Request"
          : _vm.currentRouteName == "settlements"
          ? "Settlements"
          : _vm.currentRouteName == "verifyRequests"
          ? "Verify Requests"
          : _vm.currentRouteName == "verifyDetails"
          ? "Verification Information"
          : _vm.currentRouteName == "teamMembers"
          ? "Team Members"
          : "")+"\n    ")]),_vm._v(" "),_c('b-nav-item-dropdown',{staticClass:"listingNavbar__profile-wrap listingNavbar__profile-container",attrs:{"right":""},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('em',{staticClass:"listingNavbar__profile"},[_c('span',{staticClass:"listingNavbar__profile-initial"},[_vm._v("\n            "+_vm._s(_vm.adminInitials))])])]},proxy:true}])},[_vm._v(" "),_c('b-dropdown-item-button',{on:{"click":_vm.logout}},[_vm._v("Logout")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-338ec56b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/navbar.vue
// module id = null
// module chunks = 